/**
 * Developer tool identifiers
 */
export type DevTool =
  | 'device-inspector'
  | 'display-template-preview'
  | 'device-ux-editor'
  | 'misconfigured-overlay'
  | 'app-inspector'
  | 'websockets'
  | 'third-party-tools'
  | 'uxds-version-rollback'
  | 'help';

/**
 * Mapping from hotkey to developer tool ID
 */
export const TOOL_HOTKEY_MAP: Record<string, DevTool> = {
  '1': 'device-inspector',
  '2': 'display-template-preview',
  '3': 'device-ux-editor',
  '4': 'misconfigured-overlay',
  '5': 'app-inspector',
  '6': 'websockets',
  '7': 'third-party-tools',
  '8': 'uxds-version-rollback',
  '0': 'help',
};

/**
 * Default developer tool shown when opening a new panel
 */
export const DEFAULT_TOOL: DevTool = 'help';

/**
 * Developer tools configuration with display names and hotkey shortcuts
 */
export const DEV_TOOLS: Array<{ id: DevTool; label: string; shortcut: string }> = [
  { id: 'device-inspector', label: 'Device Inspector', shortcut: '1' },
  { id: 'display-template-preview', label: 'Template Preview', shortcut: '2' },
  { id: 'device-ux-editor', label: 'Device UX', shortcut: '3' },
  { id: 'misconfigured-overlay', label: 'Misconfigured', shortcut: '4' },
  { id: 'app-inspector', label: 'App Inspector', shortcut: '5' },
  { id: 'websockets', label: 'Websockets', shortcut: '6' },
  { id: 'third-party-tools', label: 'Third Party', shortcut: '7' },
  { id: 'uxds-version-rollback', label: 'Version Rollback', shortcut: '8' },
  { id: 'help', label: 'Help', shortcut: '0' },
];
